import React from 'react';
// import { Link } from 'react-router';
// import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { ToastContainer, toast } from 'react-toastify';
import * as appointmentActions from '../../actions/appointmentActions';
import 'react-toastify/dist/ReactToastify.css';
import {
	Modal,
} from 'react-bootstrap';
// import classNames from 'classnames';
import * as constant from '../../constants/constant';
// import validator from './../common/validator.js';
// const autoBind = require('auto-bind');
import StarRatingComponent from 'react-star-rating-component';
// import { browserHistory } from 'react-router';
import _ from 'underscore';

const style = {
	// textAlign: 'center',
	fontWeight: 600,
	fontSize: 14
}
class Rating extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			modalOpen: true,
			firstTimeLoad: true,
			defualtRate: constant.DEFAULT_RATING_STARS,
			ratingQuestions: [],
			feedback: { value: '', message: '', isValid: true },
			ratingRemainder: { value: '', message: '', isValid: true },
			spinner: false,
			errorFlag: ''
		};
		this.onStarClick = this.onStarClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.setQuestionId = this.setQuestionId.bind(this);
		this.submitFeedback = this.submitFeedback.bind(this);

	}

	submitFeedback(event) {

		event.preventDefault();
		this.setState({ spinner: true });
		var ratingRecord = [];
		var state = this.state;
		// for (var i = 0; i < state.ratingQuestions.length; i++) {
		// 	ratingRecord.push(state["rate" + i]);
		// }

		// var arrRate = _.pluck(ratingRecord, 'value');

		if ((this.state.feedback.value && this.state.feedback.value != '')) {
			var obj = {
				feedbackId: this.props.editFeedbackId,
				appointmentId: this.props.appointmentId,
				patientFeedback: this.state.feedback.value,
				userId: localStorage.getItem('userId'),
				oldFeedback: this.props.previousFeedbackValue
			}

			this.props.actions.editRatingByPatient(obj);

			this.props.closeModal();
		} else {
			this.setState({ errorFlag: 'Add your valuable feedback', spinner: false });
		}


	}
	setQuestionId(index, name) {
		var state = this.state;
		state[name].ratingQId = state.ratingQuestions[index]._id;
		this.setState(state);
	}
	onStarClick(nextValue, prevValue, name) {
		var state = this.state;
		state.firstTimeLoad = false;
		state[name] = { value: state.defualtRate, ratingQId: '' }
		state[name].value = nextValue;
		state.errorFlag = '';
		this.setState(state);
		var splitArr = name.split("rate");
		this.setQuestionId(splitArr[1], name);

	}
	onChange(event) {
		var state = this.state;
		state.firstTimeLoad = false;
		if (event.target.name == "ratingRemainder") {
			let flag = (event.target.value == 'false' || event.target.value == '');
			state[event.target.name].value = flag == true ? true : false;
			this.setState(state);
		} else {
			state[event.target.name].value = event.target.value;
			state.errorFlag = '';
			this.setState(state);
		}
	}
	componentDidMount() {

	}
	componentWillReceiveProps(nextProps) {

	}
	componentWillMount() {
		var state = this.state;
		state.ratingQuestions = this.props.previousRateData;

		if (state.firstTimeLoad) {
			for (var i = 0; i < state.ratingQuestions.length; i++) {
				// console.log("state.ratingQuestions[i]", state.ratingQuestions[i]);
				state['rate' + i] = { value: state.ratingQuestions[i].value, ratingQId: state.ratingQuestions[i].ratingQId._id }
				this.setState(state);
			}
		}
		// state.spinner = (nextProps.ratingSucess == false || nextProps.ratingSucess == true) ? nextProps.ratingSucess : state.spinner;
		this.setState(state);

	}
	componentDidUpdate(prevProps, prevState) {

	}
	render() {
		var ratingQuestions = this.state.ratingQuestions;
		return (
			<Modal show={this.props.modalOpen} size="modal-sm" onHide={this.props.openReminder}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.openReminder} /> */}
				</Modal.Header>
				<Modal.Body>
					<form className="signup-form" id="loginForm" >
						<div style={style}>
							{(ratingQuestions && ratingQuestions.length > 0) ?
								ratingQuestions.map((option, index) =>
									<div key={index} className="row tatingStart">
										<div className="col-sm-8">{option.ratingQId.question}</div>
										<div className="col-sm-4">
											<StarRatingComponent
												name={'rate' + index}
												id={'rate' + index}
												value={this.state['rate' + index] ? this.state['rate' + index].value : this.state.defualtRate}
												editing={false}
												starCount={5}
												emptyStarColor={'#D3D3D3'}
												onStarClick={this.onStarClick.bind(this)}
												renderStarIcon={(index, value) => {
													return (
														<span >
															{index <= value ? <span><img src={require('../../images/start_icon.png')} /></span> : <span ><img src={require('../../images/start_icon_off.png')} /></span>}
														</span>
													);
												}}
											/>
										</div>
									</div>)
								: ''}
							<div>
								<br />
								<p>Tell us about your experience with Dr. <span className="text-capitalize">{this.props.doctorName}</span></p>
								<textarea onChange={this.onChange.bind(this)} className="form-control textinput" id="fake-file-input-name" value={this.state.feedback ? this.state.feedback.value : ''} placeholder="Type here..." name='feedback' />

							</div>
						</div>
						<div>
							<span className="help-block">{this.state.errorFlag}</span>
						</div>
						{/* <div className="bottomBtn"> */}
						<div className="feedbackBtn">
							< button style={{ marginTop: 47, marginLeft: 125 }} type="submit" className="btn btn-warning btn-lg" onClick={this.submitFeedback}>Submit{this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
						</div>
						{/* </div> */}

						<div style={{
							marginTop: 11, fontSize: 12, marginLeft: 114, cursor: 'pointer'
						}} className="checkbox checkbox-primary checkboxInline">
							<input type="checkbox" value={this.state.ratingRemainder ? this.state.ratingRemainder.value : ''} checked={this.state.ratingRemainder && this.state.ratingRemainder.value == true ? true : ''} onChange={this.onChange} name="ratingRemainder" id="ratingRemainder" />

							{/* <label htmlFor="ratingRemainder" className="startReview">
								<span>Do not remind me again</span> </label> */}
						</div>
					</form>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		ratingQuestions: state.appointment.ratingQuestions,
		ratingSucess: state.appointment.ratingSucess
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Rating);
